import { render, staticRenderFns } from "./PostCreatorModal.vue?vue&type=template&id=7fffed8b&"
import script from "./PostCreatorModal.vue?vue&type=script&lang=js&"
export * from "./PostCreatorModal.vue?vue&type=script&lang=js&"
import style0 from "./PostCreatorModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports